import {
    SETTLE_MANUALLY_FAILED,
    SETTLE_MANUALLY_SUCCEEDED,
    SEND_REMINDER_FAILED,
    SEND_REMINDER_SUCCEEDED,
    RESET_SEND_REMINDER,
    RESET_SETTLE_MANUALLY
} from "../actions/types/invoice.types";

const initialState = {
    settleManuallyState: "idle",
    sendReminderState: "idle"
};

export default function InvoicePaymentReduder (state = initialState, {type, payload}) {
    switch (type) {
        case SETTLE_MANUALLY_FAILED:
            return {
                ...state,
                settleManuallyState: "failed"
            }
        case SETTLE_MANUALLY_SUCCEEDED:
            return {
                ...state,
                settleManuallyState: "success"
            };
        case SEND_REMINDER_FAILED:
            return {
                ...state,
                sendReminderState: "failed"
            }
        case SEND_REMINDER_SUCCEEDED:
            return {
                ...state,
                sendReminderState: "success"
            }
        case RESET_SEND_REMINDER:
            return {
                ...state,
                sendReminderState: "idle"
            }
        case RESET_SETTLE_MANUALLY:
            return {
                ...state,
                settleManuallyState: "idle"
            }
        default:
            return state;
    }
}